import React, { Component } from 'react'
import { 
  Container,
  Col, 
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import { Redirect } from 'react-router-dom';
import './Admin.css'
import AdminAddFood from './AdminAddFood';
import AdminOrdersTable from './AdminOrdersTable';
import AdminSetMenu from './AdminSetMenu';
import AdminEvents from './AdminEvents';

export default class Admin extends Component {
  
  state = {
    isLoggedIn: undefined,
    nav: 1
  }

  getLocalProfile = (callback) => {
		var profileToken = localStorage.getItem("PROFILE_TOKEN");
		var profileReAuthEmail = localStorage.getItem("PROFILE_REAUTH_EMAIL");

		return ( profileReAuthEmail !== null && profileToken !== null) 
	}

  handleClose = () => {
    this.setState({ show: false });
  }


  handleNav = (k) => {
    this.setState({nav: k});
  }



  render() {

    return (this.getLocalProfile() !== true 
		? <Redirect to='/login' />
		:
      <div>
        <Container>
          <Col md={12} className="admin">
          
            <Nav tabs>
              <NavItem>
                <NavLink active={this.state.nav === 1} onClick={() => this.handleNav(1)}>Orders</NavLink>
              </NavItem>
              <NavItem>
                <NavLink active={this.state.nav === 2} onClick={() => this.handleNav(2)}>Set Menu</NavLink>
              </NavItem>
              <NavItem>
                <NavLink active={this.state.nav === 3} onClick={() => this.handleNav(3)}>Add</NavLink>
              </NavItem>
              <NavItem>
                <NavLink active={this.state.nav === 4} onClick={() => this.handleNav(4)}>Events</NavLink>
              </NavItem>
            </Nav>

            <div style={{background: '#fff3cd', color: '#856404', padding: '12px', margin: '12px 0', borderRadius: '4px', textAlign: 'center'}}>
              Demo mode — admin actions are disabled in this portfolio preview.
            </div>

            <div className="admin-container">
              {(this.state.nav === 1) && <AdminOrdersTable orders={this.state.orders} />}
              {(this.state.nav === 2) && <AdminSetMenu />}
              {(this.state.nav === 3) && <AdminAddFood />}
              {(this.state.nav === 4) && <AdminEvents />}
            </div>

          </Col>
        </Container>
      </div>
    )
  }
}
